import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useAppSelector } from "../../../hooks/redux";
import ARMSTable from "./ARMSTable";
import AddSubdivision from "./AddSubdivision";
import EditSubdivision from "./EditSubdivision";

const ARMS = () => {
    const [tabValue, setTabValue] = useState(0);
    const { permissions } = useAppSelector((state) => state.permissions);
      const { roleId } = useAppSelector((state) => state.users.info);

    function handleChangeTab(_, newValue) {
        setTabValue(newValue);
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {permissions.includes("subdivisions") && roleId !== 11 && (
                <Tabs value={tabValue} onChange={handleChangeTab} className="objects-tabs" sx={{ mb: 0 }}>
                    <Tab className="label" label={"Список АРМов"} />
                    <Tab className="label" label={"Добавить подразделение"} />
                    <Tab className="label" label={"Редактировать подразделения"} />
                </Tabs>
            )}

            {permissions.includes("subdivisions") && roleId !== 11 ? (
                <>
                    {tabValue === 0 && <ARMSTable />}
                    {tabValue === 1 && <AddSubdivision />}
                    {tabValue === 2 && <EditSubdivision />}
                </>
            ) : (
                <ARMSTable />
            )}
        </Box>
    );
};

export default ARMS;
